<template>
  <pt-lot-list class="pt-lot-list__withData"></pt-lot-list>
</template>

<script>
import PtLotList from './index'
export default {
  name: 'pt-lot-list__withData',
  components: {
    'pt-lot-list': PtLotList
  }
}
</script>
